
// expand

import AriaExpand from './AriaExpand';

const selectors = {
	button : '.js-expand-button',
	content : '.js-expand-content'
};

function init() {
	
	$(selectors.button).each(function() {
		let $button = $(this);
		let $content = $(this).next(selectors.content);
		if (!$button.length || !$content.length) return;
		const expand = new AriaExpand($button, $content, 'is-open');
	});
}



export default {
	init
}